import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7c5795db"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "https://beamian-kb.atlassian.net/servicedesk/customer/portal/9",
  target: "_blank"
}, " Help center ", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "https://info.beamian.com/about-beamian",
  target: "_blank"
}, " About us ", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "https://info.beamian.com/need-more-than-check-in",
  target: "_blank"
}, " Need more than check-in? ", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))

import { useAppStore } from "@/stores/app";
import { useUserStore } from "@/stores/user";
import {
  IonList,
  IonHeader,
  IonToolbar,
  IonPage,
  IonTitle,
  IonToggle,
  IonLabel,
  IonItem,
  IonContent,
  IonIcon,
  IonFooter,
} from "@ionic/vue";
import {
  home,
  moon,
  add,
  settings,
  swapHorizontal,
  help,
  information,
  globe,
  personCircle,
  logOutOutline,
} from "ionicons/icons";
import { usePlansStore } from "@/stores/plans";

import { computed } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'Hamburger',
  setup(__props) {

const userStore = useUserStore();
const appStore = useAppStore();
const plansStore = usePlansStore();
const dark_mode = appStore.settings.theme === "dark";

const limit_events_reached = computed(() => userStore.related.events.length >= plansStore.currentPlan.check_in_max_events)


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonPage), null, {
    default: _withCtx(() => [
      _createVNode(_unref(IonHeader), null, {
        default: _withCtx(() => [
          _createVNode(_unref(IonToolbar), null, {
            default: _withCtx(() => [
              _createVNode(_unref(IonTitle), null, {
                default: _withCtx(() => [
                  _createTextVNode("Navigation")
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_unref(IonContent), null, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(_unref(IonList), { class: "ion-margin-top" }, {
              default: _withCtx(() => [
                _createVNode(_unref(IonItem), { href: "/home" }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(IonIcon), {
                      icon: _unref(home),
                      slot: "start"
                    }, null, 8, ["icon"]),
                    _createTextVNode(" Home ")
                  ]),
                  _: 1
                }),
                (!limit_events_reached.value)
                  ? (_openBlock(), _createBlock(_unref(IonItem), {
                      key: 0,
                      href: "/onboarding/new-event"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(IonIcon), {
                          icon: _unref(add),
                          slot: "start"
                        }, null, 8, ["icon"]),
                        _createTextVNode(" Create event ")
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                _createVNode(_unref(IonItem), { href: "/manage-events" }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(IonIcon), {
                      icon: _unref(settings),
                      slot: "start"
                    }, null, 8, ["icon"]),
                    _createTextVNode(" Manage Events ")
                  ]),
                  _: 1
                }),
                (_unref(userStore).userIsAdmin)
                  ? (_openBlock(), _createBlock(_unref(IonItem), {
                      key: 1,
                      href: "/events"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(IonIcon), {
                          icon: _unref(swapHorizontal),
                          slot: "start"
                        }, null, 8, ["icon"]),
                        _createTextVNode(" Change event ")
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                _createVNode(_unref(IonItem), null, {
                  default: _withCtx(() => [
                    _createVNode(_unref(IonIcon), {
                      icon: _unref(help),
                      slot: "start"
                    }, null, 8, ["icon"]),
                    _hoisted_2
                  ]),
                  _: 1
                }),
                _createVNode(_unref(IonItem), null, {
                  default: _withCtx(() => [
                    _createVNode(_unref(IonIcon), {
                      icon: _unref(information),
                      slot: "start"
                    }, null, 8, ["icon"]),
                    _hoisted_3
                  ]),
                  _: 1
                }),
                _createVNode(_unref(IonItem), null, {
                  default: _withCtx(() => [
                    _createVNode(_unref(IonIcon), {
                      icon: _unref(globe),
                      slot: "start"
                    }, null, 8, ["icon"]),
                    _hoisted_4
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _hoisted_5,
            (_unref(userStore).me.email)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createElementVNode("small", null, _toDisplayString(_unref(userStore).me.email), 1),
                  _createVNode(_unref(IonList), null, {
                    default: _withCtx(() => [
                      _createVNode(_unref(IonItem), { href: "/my-account" }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(IonIcon), {
                            icon: _unref(personCircle),
                            slot: "start"
                          }, null, 8, ["icon"]),
                          _createTextVNode(" My profile ")
                        ]),
                        _: 1
                      }),
                      _createVNode(_unref(IonItem), { href: "/login" }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(IonIcon), {
                            icon: _unref(logOutOutline),
                            slot: "start"
                          }, null, 8, ["icon"]),
                          _createTextVNode(" Log out ")
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ], 64))
              : _createCommentVNode("", true)
          ])
        ]),
        _: 1
      }),
      _createVNode(_unref(IonFooter), null, {
        default: _withCtx(() => [
          _createVNode(_unref(IonItem), { style: {"--border-color":"var(--ion-color-light)"} }, {
            default: _withCtx(() => [
              _createVNode(_unref(IonIcon), {
                icon: _unref(moon),
                slot: "start"
              }, null, 8, ["icon"]),
              _createVNode(_unref(IonLabel), null, {
                default: _withCtx(() => [
                  _createTextVNode("Dark mode")
                ]),
                _: 1
              }),
              _createVNode(_unref(IonToggle), {
                checked: dark_mode,
                slot: "end",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(appStore).toggleTheme()))
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})